module.exports = __webpack_public_path__ + "dist/img/itb-logo.64e3868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/itb-logo.png
// module id = UM0G
// module chunks = 1